// @ts-nocheck
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useOfficials(statusFilter?: string) {
  return useQuery({
    queryKey: ["officials", statusFilter],
    queryFn: async () => {
      let q = supabase.from("manage_officials").select("*").order("name");
      if (statusFilter && statusFilter !== "all") q = q.eq("status", statusFilter);
      const { data, error } = await q;
      if (error) throw error;
      return data;
    },
  });
}

export function useOfficialAssignments(eventId: string | null) {
  return useQuery({
    queryKey: ["official-assignments", eventId],
    enabled: !!eventId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_official_assignments")
        .select("*, official:manage_officials(*)")
        .eq("event_id", eventId!);
      if (error) throw error;
      return data;
    },
  });
}

export function useOfficialAvailability(eventId: string | null) {
  return useQuery({
    queryKey: ["official-availability", eventId],
    enabled: !!eventId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_official_availability")
        .select("*, official:manage_officials(id, name, city, state)")
        .eq("event_id", eventId!);
      if (error) throw error;
      return data;
    },
  });
}

export function useOfficialAvailabilityAll() {
  return useQuery({
    queryKey: ["official-availability-all"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_official_availability")
        .select("*");
      if (error) throw error;
      return data;
    },
  });
}

export function useOfficialsEventSummary(eventId: string | null) {
  return useQuery({
    queryKey: ["officials-event-summary", eventId],
    enabled: !!eventId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_officials_event_summary")
        .select("*")
        .eq("event_id", eventId!);
      if (error) throw error;
      return data;
    },
  });
}

export function useUpcomingEventsForOfficials() {
  return useQuery({
    queryKey: ["upcoming-events-for-officials"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("events")
        .select("id, name, start_date, end_date, venue_id, venue_name, venue_city, additional_venue_ids")
        .gte("end_date", new Date().toISOString().split("T")[0])
        .order("start_date");
      if (error) throw error;
      return data;
    },
  });
}

export function useVenuesForOfficials(venueIds: string[]) {
  return useQuery({
    queryKey: ["venues-for-officials", venueIds],
    enabled: venueIds.length > 0,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("venues")
        .select("id, name, city, state")
        .in("id", venueIds);
      if (error) throw error;
      return data;
    },
  });
}

export function useVenueCourts(eventId: string | null) {
  return useQuery({
    queryKey: ["event-courts", eventId],
    enabled: !!eventId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("event_courts")
        .select("*")
        .eq("event_id", eventId!)
        .eq("is_active", true)
        .order("sort_order");
      if (error) throw error;
      return data;
    },
  });
}

export function useOfficialDetail(officialId: string | null) {
  return useQuery({
    queryKey: ["official-detail-assignments", officialId],
    enabled: !!officialId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_official_assignments")
        .select("*, event:events(id, name, start_date, end_date)")
        .eq("official_id", officialId!)
        .order("assignment_date", { ascending: false });
      if (error) throw error;
      return data;
    },
  });
}
